export default __webpack_public_path__ + "static/media/GoalImg11.003c0dea.png";